import type { FeatureFlagKey } from '@discover/domain'
import { useFeatureFlagsStore } from '../stores/featureFlagsStore'

/**
 * Hook to check if a feature flag is enabled for the logged-in user's organization
 * Reads from the feature flags store which is automatically populated from backend responses
 * @param flagKey - The feature flag key to check
 */
export function useFeatureFlag(flagKey: FeatureFlagKey): {
	isEnabled: boolean
	isLoading: boolean
} {
	const isEnabled = useFeatureFlagsStore((state) => state.isEnabled(flagKey))
	const lastUpdated = useFeatureFlagsStore((state) => state.lastUpdated)

	// If flags haven't been loaded yet, show loading state
	const isLoading = !lastUpdated

	return {
		isEnabled: isLoading ? false : isEnabled,
		isLoading,
	}
}
